import { call, put, takeLatest } from "redux-saga/effects";
import {
    FETCH_MISSING_APP_REQUEST,
    fetchMissingAppSuccess,
    fetchMissingAppFailure,
    UPDATE_MISSING_APP_REQUEST,
    updateMissingAppSuccess,
    updateMissingAppFailure,
    SEARCH_MISSING_APP_REQUEST,
    searchMissingAppSuccess,
    searchMissingAppFailure,
    updateLocalMissingApp,
    FETCH_RESOLVE_AND_UNRESOLVE_REQUEST,
    fetchResolveAndUnResolveSuccess,
    fetchResolveAndUnResolveFailure,
} from "./missingAppAction";
import SDK from "../../../config";


function* fetchMissingApps(action) {
    const { page, limit } = action.payload;
    try {
        const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/get/missing/app?page=${page}&limit=${limit}`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const data = yield response.json();
        yield put(fetchMissingAppSuccess(data.data));
    } catch (error) {
        yield put(fetchMissingAppFailure(error.toString()));
    }
}

function* searchDevices(action) {
    const { searchTerm } = action.payload;
    try {
        const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/missing/app/search?searchTerm=${searchTerm}`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const data = yield response.json();

        yield put(searchMissingAppSuccess(data.data));
    } catch (error) {
        yield put(updateMissingAppFailure(error.toString()));
    }
}

function* updateDevice(action) {
    try {
        const { appId, urlScheme, foundStatus } = action.payload;
        const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/update/missing/app`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ appId, urlScheme, foundStatus }),
        });
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const data = yield response.json();
        yield put(updateLocalMissingApp(data));
        yield put(updateMissingAppSuccess(data));
    } catch (error) {
        yield put(searchMissingAppFailure(error.toString()));
    }
}

function* fetchResolveAndUnresolveApps() {
    try {
        const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/get/resolve/app`);

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const data = yield response.json();

        yield put(fetchResolveAndUnResolveSuccess(data.data));
    } catch (error) {
        yield put(fetchResolveAndUnResolveFailure(error.toString()));
    }
}


function* missingAppSaga() {
    yield takeLatest(FETCH_MISSING_APP_REQUEST, fetchMissingApps);
    yield takeLatest(UPDATE_MISSING_APP_REQUEST, updateDevice);
    yield takeLatest(SEARCH_MISSING_APP_REQUEST, searchDevices);
    yield takeLatest(FETCH_RESOLVE_AND_UNRESOLVE_REQUEST, fetchResolveAndUnresolveApps);
}

export default missingAppSaga;
